import React from 'react';
import styled from 'styled-components';
import Button from '../components/Button';
import * as types from './actionTypes';

const AlertBaseContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const AlertText = styled.div`
  justify-content: center;
  text-align: center;
  width: ${props => typeof props.modalText === String ? '70%' : '100%'};
  margin: 5%;
  display: flex;
  align-self: center;
  font-size: 18px;
  color: #313234;
`;

export function showModal(modalComponent, _options) {
  const modalOptions = {
    onModalHide: null,
    showClose: true,
    disableBackdropClick: false,
    fullscreen: false,
    style: {},
    ..._options,
  };
  return {
    type: types.SHOW_MODAL,
    modalComponent,
    modalOptions,
  };
}

export function hideModal() {
  return { type: types.HIDE_MODAL };
}

export function showAlertModal(
  modalText,
  buttonText = 'OK',
  callback = () => { }
) {
  return dispatch => {
    const alertBase = (
      <AlertBaseContainer>
        <AlertText modalText={modalText}>
          {modalText}
        </AlertText>
        <Button
          rounded={true}
          style={{
            flex: '1 0 50px',
            alignSelf: 'center',
            margin: '5% 0 10% 0',
            width: '70%',
          }}
          submit={() => {
            dispatch(hideModal());
            callback();
          }}
          type="primary"
          label={buttonText}
        />
      </AlertBaseContainer>
    );
    dispatch(showModal(alertBase, callback));
  };
}

export function showOptionModal(
  modalText,
  callback = () => { },
  buttonLeftText = 'OK',
  buttonRightText = 'Cancel'
) {
  return dispatch => {
    const alertBase = (
      <AlertBaseContainer>
        <AlertText modalText="">
          {modalText}
        </AlertText>
        <Button
          rounded={true}
          style={{
            alignSelf: 'center',
            margin: '5% 3% 10%',
            flex: 1,
          }}
          submit={() => {
            dispatch(hideModal());
            callback(buttonLeftText);
          }}
          type="primary"
          label={buttonLeftText}
        />
        <Button
          rounded={true}
          style={{
            alignSelf: 'center',
            margin: '5% 3% 10%',
            flex: 1,
          }}
          submit={() => {
            dispatch(hideModal());
            callback(buttonRightText);
          }}
          type="primary"
          label={buttonRightText}
        />
      </AlertBaseContainer>
    );
    dispatch(showModal(alertBase, callback));
  };
}
